import React from 'react';

import {
  Flexbox,
  TextElement,
  RadioInput,
  Checkbox
} from '@ibinder/ui-common-core';
import { RichEditor } from '@ibinder/ui-common-richeditor';

import {
  Actionbar,
  Form,
  Col,
  Row,
  NumberInput,
  PaddingContainer,
  MarginContainer
} from './GeneralSettings.styles';
import { form, statusRadio, omsTypeRadio } from './GeneralSettings.constants';
import { RequiredField } from '../../../../components/RequiredLabel';

const ActionBarContainer = ({ children, ...props }) => {
  return (
    <Actionbar {...props}>
      <PaddingContainer>{children}</PaddingContainer>
    </Actionbar>
  );
};

export const GeneralSettingsView = ({
  data,
  updateData,
  editorState,
  updateDescription,
  updateOrderingSystem,
  renderFormField,
  updateOMSType,
  renderOMSFields
}) => {
  return (
    <div>
      <div>
        <ActionBarContainer makeSticky={false}>
          <span>Status</span>
        </ActionBarContainer>
        <PaddingContainer>
          <Flexbox>
            <RadioInput
              id="status"
              onClick={(k) => updateData('isEnabled', k)}
              selectedKey={data?.isEnabled ?? true}
              data={statusRadio}
            />
          </Flexbox>
        </PaddingContainer>
      </div>
      <MarginContainer>
        <ActionBarContainer hideBorderTop makeSticky={false}>
          <span>Provider information</span>
        </ActionBarContainer>
        <PaddingContainer>
          <Form>
            <Col>
              {data &&
                form.map((node) =>
                  node.type === 'row' ? (
                    <Row gap={node.gap}>
                      {node.items.map((formFiled) =>
                        renderFormField(formFiled)
                      )}
                    </Row>
                  ) : (
                    renderFormField(node)
                  )
                )}
            </Col>
            <Col gap={0.25}>
              <TextElement fontStyle="smallFont" color="discrete70">
                Description
              </TextElement>
              <RichEditor
                padding={0}
                editorState={editorState}
                onEditorStateChange={updateDescription}
                toolbar={{
                  options: ['inline', 'list', 'link']
                }}
              />
            </Col>
          </Form>
        </PaddingContainer>
      </MarginContainer>
      <MarginContainer>
        <ActionBarContainer hideBorderTop makeSticky={false}>
          <RequiredField required>Ordering system</RequiredField>
        </ActionBarContainer>
        <PaddingContainer>
          <Flexbox>
            <Checkbox
              label="Byggnet"
              checked={data?.orderingSystems?.find(
                ({ id }) => id === 'Byggnet'
              )}
              onChange={(e) =>
                updateOrderingSystem(e.target.checked, 'Byggnet')
              }
            />
            <Checkbox
              label="iBinder"
              checked={data?.orderingSystems?.find(
                ({ id }) => id === 'iBinder'
              )}
              onChange={(e) =>
                updateOrderingSystem(e.target.checked, 'iBinder')
              }
            />
          </Flexbox>
        </PaddingContainer>
      </MarginContainer>
      <MarginContainer>
        <ActionBarContainer hideBorderTop makeSticky={false}>
          <span>Organization ID</span>
        </ActionBarContainer>
        <PaddingContainer>
          <Checkbox
            label="Organization ID is required"
            checked={data?.isOrgIdRequired}
            onChange={(e) => updateData('isOrgIdRequired', e.target.checked)}
          />
        </PaddingContainer>
      </MarginContainer>
      <MarginContainer>
        <ActionBarContainer hideBorderTop makeSticky={false}>
          <span>Standard delivery</span>
        </ActionBarContainer>
        <PaddingContainer>
          <MarginContainer margin={0.5}>
            <Row alignItems="center" gap={0.5}>
              <TextElement>Between</TextElement>
              <NumberInput
                name="standardDeliveryMinDays"
                value={data?.deliveryOptions?.standardDeliveryMinDays}
                changeValue={(e) =>
                  updateData('deliveryOptions', {
                    ...data?.deliveryOptions,
                    standardDeliveryMinDays: e.target.value
                  })
                }
              />
              <TextElement>and</TextElement>
              <NumberInput
                name="standardDeliveryMaxDays"
                value={data?.deliveryOptions?.standardDeliveryMaxDays}
                changeValue={(e) =>
                  updateData('deliveryOptions', {
                    ...data?.deliveryOptions,
                    standardDeliveryMaxDays: e.target.value
                  })
                }
              />
              <TextElement>working days</TextElement>
            </Row>
          </MarginContainer>
        </PaddingContainer>
      </MarginContainer>
      <MarginContainer>
        <ActionBarContainer hideBorderTop makeSticky={false}>
          <span>Express delivery</span>
        </ActionBarContainer>
        <PaddingContainer>
          <Row gap={1} alignItems="end">
            <Checkbox
              label="Express delivery is available"
              checked={data?.deliveryOptions?.expressDeliveryEnabled}
              onChange={(e) =>
                updateData('deliveryOptions', {
                  ...data?.deliveryOptions,
                  expressDeliveryEnabled: e.target.checked
                })
              }
            />
            <Row alignItems="center" gap={0.5}>
              <NumberInput
                name="expressDeliveryTime"
                value={data?.deliveryOptions?.expressDeliveryMinHours}
                changeValue={(e) =>
                  updateData('deliveryOptions', {
                    ...data?.deliveryOptions,
                    expressDeliveryMinHours: e.target.value
                  })
                }
              />
              <TextElement>Delivery time (hours)</TextElement>
            </Row>
          </Row>
        </PaddingContainer>
      </MarginContainer>
      <MarginContainer>
        <ActionBarContainer hideBorderTop makeSticky={false}>
          <span>Order management system</span>
        </ActionBarContainer>
        <PaddingContainer>
          <Flexbox>
            <RadioInput
              id="omsType"
              onClick={(k) => updateOMSType(k)}
              selectedKey={data?.omsType ?? 'Standard'}
              data={omsTypeRadio}
            />
          </Flexbox>
          <MarginContainer margin={1}>{renderOMSFields()}</MarginContainer>
        </PaddingContainer>
      </MarginContainer>
    </div>
  );
};
